import { render, staticRenderFns } from "./OrderDetails.vue?vue&type=template&id=e79d37dc&scoped=true&"
import script from "./OrderDetails.vue?vue&type=script&lang=js&"
export * from "./OrderDetails.vue?vue&type=script&lang=js&"
import style0 from "./OrderDetails.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./OrderDetails.vue?vue&type=style&index=1&id=e79d37dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e79d37dc",
  null
  
)

export default component.exports